// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"984e878c","1079":"aedf1de3","1175":"aedf1de3","5286":"f7c830e4","8517":"fde45f89"}[chunkId] + ".chunk.css";
};